import { createRequest, delay } from '@/utils'
import { statGroupMap, eventIdMap } from '@/configs/report'

const { post } = createRequest({ urlPrefix: 'https://system.baicizhan.com' })

/**
 * 事件上报
 * @param {object} options
 * @param {string} options.statGroup 统计分组
 * @param {string} options.eventId 事件 ID
 * @param {Record<string, any>} [options.extraInfo] 额外信息
 */
export function reportEvent(options) {
  const endpoint = '/api/system/report_event'
  const { statGroup, eventId, extraInfo } = options

  return Promise.race([
    delay(1000),
    post(endpoint, {
      headers: { 'Content-Type': 'text/plain' },
      body: [
        {
          log_time: Date.now(),
          product_id: 'bcz_app_h5',
          stat_group: statGroup,
          event_id: eventId,
          extra_info: extraInfo ? JSON.stringify(extraInfo) : undefined,
        },
      ],
      globalError: false,
    }).catch(() => null),
  ])
}

reportEvent.statGroupMap = statGroupMap
reportEvent.eventIdMap = eventIdMap
